export default (fields) => fields.join(',');
